"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Twitter = function Twitter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.9871 10.1633L22.7251 0.00616455H20.6545L13.0673 8.82547L7.00749 0.00616455H0.0181885L9.18185 13.3425L0.0181885 23.9938H2.08892L10.1011 14.6804L16.5008 23.9938H23.4901L13.9866 10.1633H13.9871ZM11.151 13.46L10.2225 12.132L2.83503 1.56498H6.01555L11.9773 10.0929L12.9058 11.4209L20.6554 22.5059H17.4749L11.151 13.4605V13.46Z",
    fill: props.fill
  })));
};

var _default = Twitter;
exports["default"] = _default;